<tbtk-input
  *ngIf="!(pathService.getCurrentPath().includes('posta') || pathService.getCurrentPath().includes('not') || pathService.getCurrentPath().includes('kimlik'))"
  [placeholder]="'SEARCHING' | translate"
  class="w-100"
  (outputChange)="onChange.emit($event)"
  (outputBlur)="onBlur.emit($event)"
  (outputFocus)="onFocus.emit($event)"
  (outputEnter)="onEnter.emit($event)"
  (outputClick)="onClick.emit($event)"
  [value]="value"
>
  <div class="ti-md ti-search search" left></div>
  <button (click)="openFilterModal($event)" id="filterButton" class="btn btn-ghost btn-sm btn-neutral ti-filter" right></button>
</tbtk-input>
<div (click)="$event.stopPropagation()" class="edit-filter-modal" *ngIf="searchService.isDetailSearchVisible$ | async">
  <ng-content select="[detailSearch]"></ng-content>
</div>
